/* Batch 2 · 9 · help card beside the FAQ on /pages/faq only. Copy is taken from live site text. */
(function(){
  if(!/^\/pages\/faq\/?$/.test(location.pathname))return;
    var sec=document.getElementById('faq-star');if(!sec)return;
      var faq=sec.querySelector('.snr-faq');if(!faq||sec.querySelector('.snr-faqhelp'))return;
        var grid=document.createElement('div');grid.className='snr-faqhelp-grid';
          faq.parentNode.insertBefore(grid,faq);grid.appendChild(faq);
            var card=document.createElement('aside');card.className='snr-faqhelp';card.setAttribute('aria-label','Help');
              card.innerHTML='<h2>Still wondering?</h2>'+
                  '<p>Order before 4pm UK time Monday to Friday, or before 11am on Saturday, and we send it the same day.</p>'+
                      '<p>Questions? <a class="snr-faqhelp__mail" href="mailto:support@starniri.com">support@starniri.com</a></p>'+
                          '<div class="snr-faqhelp__cta"><a class="snr-btn snr-btn--sm" href="/pages/gift-finder">Gift finder</a><a class="snr-btn snr-btn--ghost snr-btn--sm" href="/pages/contact">Contact us</a></div>';
                            grid.appendChild(card);
                            })();
                            